import gql from 'graphql-tag';

import { Query } from 'core/index';

import { PROJECT_CONNECTION_FIELDS } from 'apps/project/gql';
import { STORY_CONNECTION_FIELDS } from 'apps/story/gql';
import { INITIATIVE_CONNECTION_FIELDS } from 'apps/initiative/gql/fragments';
import { PROFILE_CONNECTION_FIELDS } from 'apps/profile/gql';

export const PROJECTS = gql`
  ${PROJECT_CONNECTION_FIELDS}
  query FeaturedProjects(
    $featuredProjectsCount: Int
    $featuredProjectsCursor: String
    $sortBy: String
    $contains: [String!]
    $notContains: [[String]]
    $filterBy: [[String!]]
  ) {
    projects(
      first: $featuredProjectsCount
      after: $featuredProjectsCursor
      sortBy: $sortBy
      contains: $contains
      notContains: $notContains
      filterBy: $filterBy
    ) {
      ...projectConnectionFields
    }
  }
`;
export class FeaturedProjectsQuery extends Query {
  static conf = {
    GQL: PROJECTS,
    varNames: [
      'featuredProjectsCount',
      'featuredProjectsCursor',
      'sortBy',
      'contains',
      'notContains',
      'filterBy',
      'featuredProjectsCount',
    ],
    resultPath: 'projects',
  };
}

export const STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query FeaturedStories($batchSize: Int, $filterBy: [[String!]]) {
    stories(first: $batchSize, filterBy: $filterBy) {
      ...storyConnectionFields
    }
  }
`;

const FEATURED_STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query FeaturedStories(
    $featuredStorysCursor: String
    $featuredStorysCount: Int
    $featuredStorysSortBy: String
    $filterBy: [[String!]]
    $contains: [String!]
  ) {
    stories(
      first: $featuredStorysCount
      after: $featuredStorysCursor
      sortBy: $featuredStorysSortBy
      filterBy: $filterBy
      contains: $contains
    ) {
      ...storyConnectionFields
    }
  }
`;

export class FeaturedStoriesQuery extends Query {
  static conf = {
    GQL: FEATURED_STORIES,
    varNames: [
      'featuredStorysCursor',
      'featuredStorysCount',
      'featuredStorysSortBy',
      'filterBy',
      'contains',
    ],
    resultPath: 'stories',
  };
}

export const INITIATIVES = gql`
  ${INITIATIVE_CONNECTION_FIELDS}
  query FeaturedInitiatives(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $filterBy: [[String!]]
  ) {
    initiatives(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      filterBy: $filterBy
    ) {
      ...initiativeConnectionFields
    }
  }
`;
export class FeaturedInitiativesQuery extends Query {
  static conf = {
    GQL: INITIATIVES,
    varNames: ['batchSize', 'cursor', 'filterBy', 'sortBy'],
    resultPath: 'initiatives',
  };
}

export const PROFILES = gql`
  ${PROFILE_CONNECTION_FIELDS}
  query FeaturedProfiles($batchSize: Int, $contains: [String!]) {
    profiles(first: $batchSize, contains: $contains) {
      ...profileConnectionFields
    }
  }
`;

export class FeaturedProfilesQuery extends Query {
  static conf = {
    GQL: PROFILES,
    varNames: ['batchSize', 'contains'],
    resultPath: 'profiles',
  };
}
